var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Voice',{attrs:{"detail":{
  no: '04',
  belong: 'ＪＲ九州ホテルブラッサム新宿',
  title: 'マネージャ―',
  profile: 'ＪＲ九州ホテルブラッサム新宿',
  name: 'ポロスオ ユスティナ マウゴジャタ',
  date: '２０１９年入社',
  sm: {
    belong: 'J R九州ホテルブラッサム新宿',
    name: 'マネージャ―',
  },
  intro: '日本の丁寧なおもてなしを体験し接客業へ。海外のお客さまから「ありがとう」と言われるたび仕事の価値を実感',
  content: [
    {
      title: 'ともに働くスタッフは、日本の家族のよう',
      text: '10代の頃日本のアニメで日本語の音の美しさに惹かれ、母国ポーランドの大学で日本語と日本文化を学びました。インターンシップのプログラムで来日し、箱根の旅館で初めて接客を体験しました。高級旅館で、朝晩で着物を着替えるなど大変さもありましたが、10ヶ月もの間日本の丁寧な「おもてなし」に触れ、もっと接客をしてみたいと感じました。その後ワーキングホリデーで再来日。友人の紹介でJ R九州ホテルブラッサム新宿へアルバイトとして入社しました。当初は１年の予定でしたがスタッフが皆やさしくて、同僚としてだけでなく大切な友人が何人もできました。ここで長く働きたいと思うようになり、正社員となって５年目です。スタッフは私にとって、日本の家族のようです。',
    },
    {
      title: '困ったら周囲が助けるから、まず自分でやってみること',
      text: '現場の仕事は支え合いで、誰かがミスをした時は他の誰かが助けに入ります。それはお客さまのためであり、自分たちのためでもあります。しかし、まずは自分で考えてやってみること。それがうまく行かなかったら、先輩に聞いてください。その方が自分で対応できるようになるし、自信が持てるようになります。人としても成長できます。私はマネージャーとしてフロントでの立ち居振舞い、お客さまへの声かけの仕方などメンバーへ伝えています。まだ知らない日本語もあるのでそこは周りのスタッフに教えてもらい、代わりに英語をサポートしています。現在はSNSの管理も担当し、お客さまから「スタッフが素晴らしい」と投稿をいただけるとLINEグループで共有しています。皆がんばっているので、とても励みになります。',
    },
    {
      title: '仕事の魅力は「お客さま」',
      text: '当ホテルのお客さまは、約８割が外国人です。世界中から日々いろいろな方が来られ、さまざまな会話があります。その方々から感謝の言葉をいただける、本当に意味のある仕事です。ある時イギリス人のお客さまでお祖母さんとお孫さんのお二人に、東京ディズニーランドへの行き方を尋ねられました。地図を作ってお渡しするととても感謝され、お土産に大きなチョコレートボックスをいただきました。私はお客さま対応が本当に楽しく日本の生活も好きなので、長く勤めたいと思っています。ポーランドで暮らす母が、いつか見にきてくれたらと願っています。',
    } ],
  career: [
    {
      year: '2019',
      text: 'ＪＲ九州ホテルブラッサム新宿に配属',
    },
    {
      year: '2022',
      text: '同ホテルでマネージャーに昇格',
      isLast: true,
    },
    {
      year: '',
      text: '',
    },
    {
      year: '',
      text: '',
    },
    {
      year: '',
      text: '',
    } ],
  message: '世界中の人と出会いたい、自信をつけたい、素晴らしい人たちと一緒に働きたいと思ったら、迷わずこの仕事に応募してください。これは成長し、新しいスキルを学ぶ絶好の機会です。お客さまから「ありがとうございました」などの言葉を聞くと、自分の仕事に価値があることを実感します。困難な時もあるかもしれませんが、スタッフメンバーがたくさんサポートを提供してくれますので安心してください。どこの国から来ても、私たちのチームの一員になりましょう！',
  caption: true,
  navi: {
    prev: {
      title: '３度の開業で得たゆるぎない経験。地域の魅力を見つけ、旅行者目線でサービス向上を目指す。',
      path: '03',
    },
    next: {
      title: '笑顔を忘れずに、温泉宿ならではのお客さま一人ひとりに寄り添うサービスを。',
      path: '05',
    },
  },
}}})}
var staticRenderFns = []

export { render, staticRenderFns }